import {Emitter, EVENTS} from './emitter';

// TODO:
// - Add support for deep copy and nested properties
// - Make state as immutable as possible
export class Store extends Emitter {
  private store: object;

  constructor(store = {}) {
    super();
    this.store = store;
  }

  public getValue(property) {
    if (!this.store.hasOwnProperty(property)) throw `State: No state item defined ${property} found`;
    return this.store[property];
  }

  public setValue(property, value) {
    if (!this.store.hasOwnProperty(property)) throw `State: No state item defined ${property} found`;
    const previous = this.store[property];
    this.store[property] = value;
    this.emit(EVENTS.stateChange, {property, value, previous});
  }

  public getState() {
    return Object.assign({}, this.store);
  }
}

// Create our application state store
export const state = new Store({
  view: {name: '', instance: null},
  first: true,
  seenScrollCopy: false
});
